import React from 'react';
import { Text } from '../../../../../../CommonComponents/OPL/Text/Text';
import { MarginProps } from '../../../../../../theme/styledProps';
import { StyledSpectrumArrow } from './SpectrumArrow.styles';

export const SpectrumArrow: React.FC<MarginProps> = props => {
  return (
    <StyledSpectrumArrow {...props}>
      <Text variant="smallCaps">Low</Text>

      <Text variant="smallCaps">Risk/Return Spectrum</Text>

      <Text variant="smallCaps">High</Text>
    </StyledSpectrumArrow>
  );
};
